export default function decimal(value: any, decimals: number): string|undefined {
  if (isNaN(value)) return value;

  let number = parseFloat(value);

  let decimalPlaces = typeof decimals !== 'undefined' ? decimals : 2;

  return number.toFixed(decimalPlaces);
}